import { usePlatformCreateReport } from '@cloudquery/api-platform';
import { useBaseAuthenticated } from '@cloudquery/base-users';
import { useNavigate } from 'react-router';

import { buildYourOwnTemplate } from '../templates';
import { generateReportObjectWithYamlFromTemplate, parseReportYaml } from '../utils';
import { getReportUrl } from '../utils/navigation';

export function useTemplate(templateId: string) {
  const { mutateAsync: createReport } = usePlatformCreateReport();

  const { currentMembership } = useBaseAuthenticated();
  const navigate = useNavigate();

  const handleCreateFromTemplate = async () => {
    const report = await generateReportObjectWithYamlFromTemplate(
      currentMembership.team.name,
      templateId,
    );
    const data = await createReport({
      data: {
        content: report.content,
        description: report.description,
        private: true,
        template_id: templateId,
        title: report.title,
      },
      teamName: currentMembership.team.name,
    });

    navigate(getReportUrl(data.data.data.id, currentMembership.team.name));
  };

  const handleCreateFromYaml = async (yaml: string) => {
    const reportContent = parseReportYaml(yaml) || {};
    const { shortDescription, title } = reportContent;

    const data = await createReport({
      data: { content: yaml, description: shortDescription, private: true, title },
      teamName: currentMembership.team.name,
    });

    navigate(getReportUrl(data.data.data.id, currentMembership.team.name, true));
  };

  return {
    handleCreateFromTemplate,
    handleCreateFromYaml,
    isCreateFromScratchTemplate: templateId === buildYourOwnTemplate.id,
  };
}
